// UserContext.js
import React, { createContext, useContext, useState, useEffect } from 'react';
import { getAuth, onAuthStateChanged } from 'firebase/auth';
import { isUserLoggedIn } from 'src/services/firebaseService';

const UserContext = createContext();
const AuthReadyContext = createContext(false);

export const UserProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  // False until the first auth state resolves — lets UI (e.g. the bottom dock)
  // show a loading state instead of flashing the wrong menu for the user type.
  const [authReady, setAuthReady] = useState(false);

  useEffect(() => {
    const auth = getAuth();
    // Subscribe to auth state changes so the menu re-renders immediately on
    // login/logout without needing a page refresh.
    const unsubscribe = onAuthStateChanged(auth, async () => {
      // Firebase has already confirmed the auth transition here, but our own
      // Firestore lookup below hasn't run yet — flipping authReady false for
      // that gap (rather than leaving it true from a previous resolution)
      // stops consumers (the dock, the menu) rendering the stale pre-login
      // state for the beat before this resolves. Login.js's own listener has
      // no async work and fires+navigates faster than this callback, which
      // is exactly the race that caused the logged-out nav to flash.
      setAuthReady(false);
      const result = await isUserLoggedIn();
      setUser(result || null);
      setAuthReady(true);
    });
    return unsubscribe;
  }, []);

  return (
    <AuthReadyContext.Provider value={authReady}>
      <UserContext.Provider value={user}>{children}</UserContext.Provider>
    </AuthReadyContext.Provider>
  );
};

export const useUser = () => useContext(UserContext);
export const useAuthReady = () => useContext(AuthReadyContext);
